import types from '../../types';

const userLoginHistory = (state = { loading: true }, { type, payload }) => {
  switch (type) {
    case types.GET_USER_LOGIN_HISTORY_SUCCESS:
      return { ...payload, loading: false };

    case types.GET_USER_LOGIN_HISTORY_START:
      return { ...state, loading: true };

    case types.GET_USER_LOGIN_HISTORY_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default userLoginHistory;
